module.exports = __webpack_public_path__ + "assets/img/coupon_0.6f19bde1.svg";